import { render, staticRenderFns } from "./EditingDialog.vue?vue&type=template&id=10b16dd5"
import script from "./EditingDialog.vue?vue&type=script&lang=js"
export * from "./EditingDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports